<template>
    <div class="addTicket">
        <!-- 添加券号信息 -->
        <el-card shadow="never" 
            v-loading="loading" 
            element-loading-text="拼命加载中"
            element-loading-spinner="el-icon-loading"
        >
            <el-row>
                <el-col :span="9">
                    <el-form 
                    :model="ruleForm" 
                    :rules="rules" 
                    ref="ruleForm"
                    label-width="100px"
                    class="demo-ruleForm"
                    >   
                        <!-- <el-form-item label="类型名称" prop="description" >
                            <el-input v-model="ruleForm.description" placeholder="请输入地点名称" :disabled="true"></el-input>
                        </el-form-item> -->
                        <el-form-item label="销售地点" prop="locationCode">
                            <el-col :span="22">
                                <el-select v-model="value9" filterable placeholder="试一试搜索:销售地点" clearable  @change="handleChange2" :loading="loading" size = "large">
                                    <el-option
                                        v-for="item in options2"
                                        :key="item.value"
                                        :label="item.label"
                                        :value="item.value"
                                    >
                                    </el-option>
                                </el-select>
                            </el-col>
                            
                        </el-form-item>
                        <el-form-item label="免费招待" prop="complimentary" >
                            <el-col :span="22">
                                <el-input v-model="ruleForm.complimentary" placeholder="请输入地点名称" :disabled="true"></el-input>
                            </el-col>
                        </el-form-item>
                        <el-form-item
                            label="券号"
                            prop="voucherCode"
                        >
                            <el-col :span="10">
                                <el-input v-model="ruleForm.voucherCode.value1" :maxlength ="8"></el-input>
                            </el-col>
                            <el-col :span="1" :offset="1"> - </el-col>
                            <el-col :span="10">
                                <el-input v-model="ruleForm.voucherCode.value2" :maxlength ="8"></el-input>
                            </el-col>
                        </el-form-item>
                        <el-form-item>
                            <el-button type="primary" @click="submitForm('ruleForm')">确认</el-button>
                            <el-button @click="cancel">返回</el-button>
                        </el-form-item>
                    </el-form>
                </el-col>
                <el-col :span ="14" :offset="1">
                    <el-card>
                        <div slot="header" class="clearfix">
                            <span><i class="el-icon-error" style="color:red;"></i> 错误信息</span>
                            <!-- <el-button style="float: right; padding: 3px 0" type="text">操作按钮</el-button> -->
                        </div>
                        <el-table
                        :data="errData"
                        height="400"
                        style="width: 100%">
                        <el-table-column
                            prop="code"
                            label="券号"
                            width="100">
                        </el-table-column>
                        <el-table-column
                            prop="status"
                            label="状态"
                            width="80">
                        </el-table-column>
                        <el-table-column
                            prop="location"
                            label="地点名称">
                        </el-table-column>
                    </el-table>
                    </el-card>
                    
                </el-col>
            </el-row>
        </el-card>
    </div>
</template>
<style lang="less">
    .line{
        text-align: center;
    }
</style>
<script>
import requestMixin from '../../mixins/request'
import common from '../../mixins/common'
import axios from '../../env/axios'
import apis from '../../env/apis'
export default {
    mixins:[requestMixin,common],
    inject:['reload'],
    data(){
        var validatorQty = (rule,value,callback) => {
            // if(value.value1 != '' && value.value2 == ''){
            //     let val = this.trim(value.value1);
            //     if((/^[+]{0,1}(\d+)$|^[+]{0,1}(\d+\.\d+)$/).test(val) == false ){
            //         callback(new Error("请填写大于0的数字"));
            //     }else{
            //         callback();
            //     }
            // }else if(value.value2 != '' && value.value1 == ''){
            //     callback(new Error("至少输入第一个券号！"));
            // }else if(value.value2 - value.value1 < 0){
            //     callback(new Error("第二位数要大于第一位数"));
            // }else if(value.value2 < 0 || value.value1 < 0){
            //     callback(new Error("必须填写大于0的数字"));
            // }else{
            //     callback();
            // }
            let value1 = Number.isInteger(value.value1) ;
            let value2 = Number.isInteger(value.value2) ;
            if(value.value1 == ''){
                callback(new Error("第一个券号不能为空！"));
            }else{
                if(value.value1 != '' && value.value2 == ''){
                    let val = this.trim(value.value1);
                    if((/^[+]{0,1}(\d+)$|^[+]{0,1}(\d+\.\d+)$/).test(val) == false){
                        callback(new Error("请填写大于0的数字"));
                    }else if(/[+]/g.test(value.value1)){
                        callback(new Error("请输入大于0的数字"));
                    }else if(value.value1.length != 8){
                        callback(new Error("请输入8位数的券号！"));
                    }
                    else{
                        callback();
                    }
                }else if(value.value2 != '' && value.value1 != ''){
                    if((/^[+]{0,1}(\d+)$|^[+]{0,1}(\d+\.\d+)$/).test(value.value2) == false || (/^[+]{0,1}(\d+)$|^[+]{0,1}(\d+\.\d+)$/).test(value.value1) == false){
                        callback(new Error("请填写大于0的数字"));
                        // console.log('两个验证都必须填写大于0的数字')
                    }else if(value.value2 - value.value1 < 0){
                        callback(new Error("第二位数要大于第一位数"));
                    }else if(value.value2 < 0 || value.value1 < 0){
                        callback(new Error("必须填写大于0的数字"));
                    }else if(/[+]/g.test(value.value2) || /[+]/g.test(value.value1)){
                        //console.log('包含加号')
                        callback(new Error("请输入大于0的数字"));
                    }else if(value.value2.length != 8 || value.value1.length != 8){
                        callback(new Error("请输入8位数的券号！"));
                    }else{
                        callback();
                    }
                }
            }
        }
        return {
            ruleForm:{
                typeCode:'',
                voucherCode:{
                    value1:"",
                    value2:""
                },
                locationCode:'',
                complimentary:''
            },
            rules:{
                voucherCode:[
                     {  validator : validatorQty,trigger:'blur',type:'number'},
                     { required: true, message: '请填写券号', trigger:'blur'}
                ],
                complimentary:[
                    { required: true, message: '请先选择类型编号'}
                ],
                typeCode:[
                    { required: true, message: '请选择类型编号', trigger:'blur'}
                ],
                locationCode: [
                    { required: true, message: '请填写地点名称', trigger: 'blur' },
                    // { min: 2, max: 100, message: '长度在 3 到 100 个字符', trigger: 'blur' }
                ],
                quantity:[
                    { required : true},
                    // { min: 1, max: 5, message: '长度在 1 到 5 个数字', trigger: 'blur' }
                ],
            },
            value9:'',
            options2:[
                {
                    value : '', 
                    label : '加载中'
                }
            ],
            selectData:'',
            errData:[],

            userLocDescription:'',
            loading:false
        }
    },
    mounted(){
        this.loadingArea();
        // this.getLocation();
    },
    methods:{
        //保存券号信息
        async submitForm(formName) {   
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.loading = true ;
                    let userId = sessionStorage.getItem("userId") ;
                    let { typeCode , voucherCode, complimentary ,locationCode} = this.ruleForm ;
                    if(complimentary == '是'){
                        complimentary = 'Y'
                    }else if(complimentary == '否'){
                        complimentary = 'N'
                    } 
                    let params = {
                        act : 'adjustments',
                        shop : locationCode ,
                        typeCode : typeCode,
                        from : voucherCode.value1,
                        to : voucherCode.value2 == "" ? voucherCode.value1 : voucherCode.value2,
                        complimentary : complimentary,
                        userId
                    }
                    console.log(locationCode)
                    let maxVal = params.to - params.from ;
                    this.errData = [];
                    if(maxVal <= 500 && maxVal >= 0){
                        this.getUserLocation().then((res) =>{
                            let code = res ;
                            let checkParams = {
                                act : 'checkrange' ,
                                from : voucherCode.value1,
                                to : voucherCode.value2 == "" ? voucherCode.value1 : voucherCode.value2,
                                checkLocation : code ,
                                checkLocationCode:locationCode,
                                checkStatus : "A,D",
                                userId
                            }
                            if(code !== params.shop){
                                // let fromShop = this.userLocDescription;
                                // this.turnCodeToDes(locationCode).then((res) =>{
                                //     console.log(res)
                                //     let wsParams = {
                                //         fromShop,
                                //         shop : res ,
                                //         from : voucherCode.value1,
                                //         to : voucherCode.value2 == "" ? voucherCode.value1 : voucherCode.value2,
                                //         locationCode,
                                //     }
                                //     let params1= JSON.stringify(wsParams)
                                 // this.websocketsend(params1);
                                // })
                                //执行
                                this.checkedRange2(checkParams,params,'调整'); 
                            }else{
                                this.loading = false ;
                                this.alert('同一门店无法调整 !','warning')
                            }
                        })
                    }else{
                        this.loading = false ;
                        this.alert('批量调整最多为500张！','warning')
                    }
                } else {
                    // console.log('error submit!!');
                    return false;
                }
            });
        },

        //点击取消，跳转到上一页
        cancel(){
            this.$router.go(-1)
        },
        /**
         * 搜索加载地区选项
        */
        loadingArea(){
            let userId = sessionStorage.getItem("userId") ;
            let params = {
                act:'findLocations',
                userId
            }
            return new Promise((resolve,reject) => {
                this.findType(params).then( (res) => {
                    // console.log(res)
                    if(res.data.status == true){
                        let result = res.data.list;
                        this.sortChinese(result,"description");
                        this.selectData = result;
                        let location = result.map( (elem, index, arr) => {
                            return { value : elem.locationCode ,label:elem.description }
                        })
                        resolve(result)
                        this.options2 = location; 
                    }
                })
            })
        },
        /**
         * websocket
         */
        getLocation(){
            let that = this;
            that.getUserLocation().then((res) =>{
                that.turnCodeToDes(res).then(data =>{
                    that.userLocDescription = data;
                })
            })
        },
        /**
         * @description 地点code转des
         */
        turnCodeToDes(locCode){
            let that = this;
            let description;
            return new Promise(resolve =>{
                that.loadingArea().then((loc) =>{
                    let locObj = loc.filter(elem =>{
                        return elem.locationCode === locCode
                    })
                    if(locObj.length>0){
                        description = locObj[0].description;
                        resolve(description)
                    }
                })
            }) 
        },




        /**
         * 销售地点change
         */
        handleChange2(value){
            this.ruleForm.locationCode = value;
            let selectData = this.selectData ;
            this.getUserLocation().then(res =>{
                if(value == res){
                    this.alert('同一门店无法调整 !','warning')
                }
            })
            selectData.forEach((elem,index,array) =>{
                if(elem.locationCode == value){
                    this.ruleForm.complimentary = elem.complimentary;
                    if(this.ruleForm.complimentary == 'Y'){
                         this.ruleForm.complimentary = '是'
                    }else{
                        this.ruleForm.complimentary = '否'
                    }
                }
            }); 
        },
        checkedRange2(checkParams,params,text){
            let that = this ;
            that.loading = true;
            that.delType(checkParams).then((res) =>{
                // console.log(res)
                let { status , errorData,msg} = res.data ;
                if(!status){
                    that.loading = false;
                    this.alert(`${msg}!`,'warning');
                }
                let len = errorData.length ;
                if( status == true && len == 0 ){
                    //执行调整
                    that.handleAtive(params,text); //处理批量调整
                }else if(status == true && len > 0){
                        //显示错误
                        that.loading = false;
                        this.alert(`不能${text},请确保券的状态是否正确!`,'warning');
                        for(let i = 0 ;i < errorData.length;i++){
                            errorData[i].status = that.formalStatus(errorData[i].status);
                            errorData[i].complimentary = 'null' ? '否' : '是' ;
                        }
                        that.errData = errorData ;

                    // checkParams.checkStatus = "A";
                    // // console.log(checkParams)
                    // that.delType(checkParams,params).then((res)=>{
                    //     let { status , errorData} = res.data ;
                    //         console.log(errorData)
                    //     let len = errorData.length ;
                    //     if(status == true && len == 0){
                    //         //执行调整
                    //         that.handleAtive(params,text); //处理批量调整
                    //     }else if(status == true && len > 0){
                    //         // this.checkedRange(checkParams,params,'调整');
                    //         //显示错误
                    //         this.alert(`不能${text},请确保券的状态是否正确!`,'warning');
                    //         for(let i = 0 ;i < errorData.length;i++){
                    //             errorData[i].status = that.formalStatus(errorData[i].status);
                    //             errorData[i].complimentary = 'null' ? '否' : '是' ;
                    //         }
                    //         that.errData = errorData ;
                    //     }
                    // })
                }
            })
        },
        /**
         * WebSocket
         */
        websocketsend(params){
            this.$store.state.socket.send(params);
        }

    }

}
</script>
